// Copyright (c) 2023-2024 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.

import mainLogo from 'assets/logo_primary.png';
import tokenLogo from 'assets/logo_secondary.png';

// App settings not adjustable by the user
const tokenConfig = {
    name: 'Trinity Trust Token', // Updated name for TTT
    ticker: 'TTT', // Updated ticker symbol for TTT
    derivationPath: 1899, // Derivation path remains the same unless specified otherwise
    logo: mainLogo, // Path to the primary logo for TTT
    legacyPrefix: 'tttlegacy', // Update to TTT-specific legacy prefix if applicable
    coingeckoId: 'ttt', // Identifier on CoinGecko for TTT (assuming TTT is listed there)
    fiatUpdateIntervalMs: 90000, // Same interval for fiat updates
    defaultFee: 4.55, // Updated fee based on the provided transaction fee data
    minFee: 1, // Keep the minimum fee consistent unless specified otherwise
    dustSats: 546, // Dust limit in satoshis; update if TTT's limit differs
    cashDecimals: 2, // Number of decimal places for TTT transactions
    fiatDecimals: 2, // Number of decimal places for fiat currency values
    pricePrecisionDecimals: 8, // Precision for displaying the price of TTT
    tokenName: 'Trinity Trust Token', // Full name for TTT
    tokenTicker: 'TTT', // Ticker symbol for TTT
    tokenLogo: tokenLogo, // Path to the token logo
    localStorageMaxCharacters: 24, // Maximum characters for local storage keys/values
    monitorExtension: false, // Same setting; update if TTT requires different monitoring
    vipTokens: {
        // Example VIP tokens for TTT; you can define specific tokens here
        tttVIP1: {
            tokenId: 'd07d686f60842c01f1d314f37e2f5e57e41a132b2f51afc7c4f62c809136b936', // Use the Token ID from the GENESIS transaction
            vipBalance: '1000000', // Example balance threshold for VIP status; adjust as needed
        },
    }, defaultLocale: 'en-US', // Locale setting; change if TTT targets a different primary region
};

export default tokenConfig;
